import React, { useState } from 'react';
import { Alert, Snackbar, AlertColor, SxProps, Theme, Fade, FadeProps } from '@mui/material';
import { alertDuration } from '../../constants';
import { customSizes, spaces } from '../../assets/styles/themes/tokens';

interface OwnProps {
    message: string;
    onClose?: () => void;
    severity?: AlertColor;
    alertSx?: SxProps<Theme>;
}

export type Alert = {
  message: string,
  severity: AlertColor
};

const NotificationAlert: React.FC<OwnProps> = (props) => {
  const [isOpen, setIsOpen] = useState(true);
  const { 
    message, 
    onClose, 
    severity = 'success',
    alertSx,
  } = props;

  const handleOnClose = () => {
    if (isOpen) {  // We don't want onClose to execute twice
      setIsOpen(false);
      if (onClose) onClose();
    }
  };

  const CustomFadeTransition = (props: FadeProps) => {
    return <Fade {...props}  />;
  };

  return (
    <Snackbar 
      open={isOpen} 
      autoHideDuration={alertDuration} 
      onClose={handleOnClose}
      TransitionComponent={CustomFadeTransition}
      sx={{
        position: 'absolute',
        height: 'min-content',
        top: `${customSizes.readerPage.paddingY} !important`,
        left: '0 !important',
        right: '0 !important',
        bottom: '0 !important',
      }}
    >
      <Alert severity={severity} onClose={handleOnClose} 
        sx={{
          borderRadius: spaces.sm,
          alignItems: 'center',
          ...alertSx,
        }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationAlert;
